import { useCallback } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';
import { ProcedureDetails } from '../types/ProcedureTypes';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getProcedureDetails = useCallback(
        async (category: number, procedureId: number) => {
            try {
                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    throw new Error('API URL not configured in app settings');
                }
                const response = await getApiData({
                    endpoint: `${apiUrl}/GetProcedure?category=${category}&id=${procedureId}`,
                });
                return response;
            } catch (error) {
                console.error(`Failed to fetch procedure details for category ${category}, ID ${procedureId}:`, error);
                throw error;
            }
        },
        [getApiData, appSettings]
    );

    return {
        procedureDetails: state.result as ProcedureDetails | null,
        loading: state.isLoading,
        error: state.error,
        getProcedureDetails,
    };
};
